export default "/images/12906235c83a55d0524a82fc8487d54f.avif";